/*
* Outstanding bids (order search) for authenticated users
*/

import { filterBy } from '@progress/kendo-data-query';
import { GridColumn as Column, Grid, GridToolbar } from '@progress/kendo-react-grid';
import * as _ from 'lodash';
import moment from 'moment';
import * as React from 'react';
import { Button, Modal, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { push } from 'react-router-redux';
import VirtualizedSelect from 'react-virtualized-select';
import { compose } from 'redux';
import { connectRequest, updateEntities } from 'redux-query';

import { ExcelExport } from '@progress/kendo-react-excel-export';
import * as Actions from '../actions';
import * as MutateActions from '../actions/mutate';
import * as AppComp from '../common/app-component-base';
import * as AppUtilities from '../common/apputilities';
import { BootstrapColXl as Col } from '../common/bootstrap/bootstrapcolxl';
import { Formatters } from '../common/formatters';
import { FormUtilities } from '../common/formutilities';
import { GridCellDropdownActionsOutstandingBids, OutstandingBidActionKeys } from '../common/grid/grid-cell-components/gridcell-dropdown-actions-bids-outstanding';
import { CellWithTruncate } from '../common/grid/grid-cell-components/gridcell-renderers';
import { GridUtilities } from '../common/grid/gridutilities';
import * as KendoWrappers from '../common/kendoforms/componentwrappers';
import { NavigationLinks } from '../common/navigation';
import { WhiteBoxPageSection } from '../common/whiteboxpagesection';
import ApiEndpoints from '../config/apiendpoints';
import AppConfiguration from '../config/configuration';
import { OrderPricing, OrderStatuses } from '../order/orderpricing';
import * as ReduxQueries from '../queries';
import { initialState } from 'src/reducers/searchFiltersOutstandingBidsReducer';

export interface IOutstandingBidsProps extends AppComp.IAppComponentProps {
    filterByClients?: any;
    filterByRegions?: any;
    filterByStatuses?: any;
    navigateTo?: any;
    dispatch?: any;
    forceRequest?: any;
    filterBySelectedOrderIds?: any;
    searchOutstandingBidsFilterClient?: any;
    searchOutstandingBidsFilterRegion?: any;
    searchOutstandingBidsFilterStatus?: any;
    searchOutstandingBidsFilterUnsolicitedBid?: any;
    updateOutstandingBid?: any;
    searchOutstandingBidsFilterFromBidDate?: any;
    searchOutstandingBidsFilterToBidDate?: any;
    searchOutstandingBidsFilterFromFollowUpDate?: any;
    searchOutstandingBidsFilterToFollowUpDate?: any;
}

export interface IOutstandingBidsState extends AppComp.IAppComponentState {
    orderChanges?: any;
    gridVirtualSkip?: any;
    gridVirtualTake?: any;
    gridFilter?: any;
    showModalUpdateOrder?: boolean;
    showModalUpdateOrderId?: any;
    orderModalFormChanges?: any;
}

export const DefaultGridPageTake: number = 50;
export const DefaultFollowUpAddInterval = 7;
export const DefaultFollowUpAddPeriod = 'days';

export class OutstandingBids extends AppComp.AppComponent<IOutstandingBidsProps, IOutstandingBidsState> {
    public MomentDateFormat: string = AppConfiguration.getMomentShortDateFormat();
    public anyOptionText: string = this.appTextFilterOptionAny();
    public originalExtendedOrderCache: Array<any> = [];
    public originalOrderModalFormDataCache: {};
    public _export;

    public constructor(props: IOutstandingBidsProps) {
        super(props, 'app.outstanding-bids.');

        this.state = {
            orderChanges: [],
            gridVirtualSkip: 0,
            gridVirtualTake: DefaultGridPageTake,
            gridFilter: undefined,
            showModalUpdateOrder: false,
            showModalUpdateOrderId: 0,
            orderModalFormChanges: {}
        };
    }

    public componentDidMount() {
        const enforce = this.enforceAdminOrEmployeeOnly();

        if (enforce) { this.props.navigateTo(NavigationLinks.clientDashboardHome()); }
    }

    public componentDidUpdate() {
        // Order modal
        let resetOrderModalFormData = this.getOrderModalFormChangesResetRequired();

        if (resetOrderModalFormData && _.size(this.state.orderModalFormChanges)) {
            this.setState({ orderModalFormChanges: {} });
        }
    }

    public getOrderModalFormChangesResetRequired() {
        let result = false;

        const pa = Formatters.getInt(this.state, 'showModalUpdateOrderId');

        // Cached values
        const ca = Formatters.getInt(this.originalOrderModalFormDataCache, 'orderId');

        // Determine if formdata state and cache needs reset due to changing associd or invid
        if (pa && ca) {
            result = (pa !== ca) ? true : false;
        }

        // console.log(`getOrderModalFormChangesResetRequired result pa ${pa} ca ${ca} => result ${result}`);

        return result;
    }

    public handleFormInputChange(e: any, x: any) {
        // console.log('handleForminputchange', {e: e, x: x });

        const getChangesResult = this.getOrderModalFormChanges(e, x);
        // console.log('handleForminputchange getChangesResult', {getChangesResult: getChangesResult, e: e, x: x });
        if (getChangesResult.applyChanges) {
            this.setState({
                orderModalFormChanges: getChangesResult.formChanges
            });
        }
    }

    public getOrderModalFormChanges(e: any, x: any) {
        let result = {
            applyChanges: false,
            formChanges: {},
            formChangesResult: {},
        };

        let fieldName = '';
        let newValue;

        let formChangesCopy = _.cloneDeep(this.state.orderModalFormChanges);

        if (_.get(e, 'target.props.name')) {
            // Kendo form element
            if (_.has(e, 'target.combobox')) {
                // combobox
                fieldName = _.get(e, 'target.props.name', '');
                newValue = _.get(e, 'target.value');
            } else {
                // assume textbox
                fieldName = _.get(e, 'target.props.name', '');
                newValue = _.get(e, 'value');
            }
        } else {
            const eventTargetType = _.get(e, 'target.type', '');

            switch (eventTargetType) {
                case 'textarea':
                case 'text':
                    fieldName = _.get(e, 'target.name', '');
                    newValue = _.get(e, 'target.value');
                    break;

                case 'kendo-dropdownlist':
                    fieldName = _.get(e, 'target.name', '');
                    newValue = _.get(e, 'target.value', '');
                    break;

                case 'virtualized-select':
                    fieldName = _.get(e, 'target.name', '');
                    newValue = _.get(x, 'value');
                    break;

                case 'delete-button':
                    fieldName = _.get(e, 'target.name', '');
                    newValue = _.get(e, 'target.value');
                    break;

                default:
                    console.log(`*** handleFormInputChange switch hit default for eventTargetType ${eventTargetType}`);
                    break;
            }
        }

        // console.log(`handleFormInputChange continuing 1 fieldName ${fieldName} newValue ${newValue}`, { e: e, x: x });

        if (!fieldName) { return result; }

        let applyChange = false;
        let origVal = _.get(this.originalOrderModalFormDataCache, fieldName);
        let formChangesResult = {};
        if (_.isArray(origVal)) {
            if (_.isArray(newValue)) {
                if (!_.isEqual(origVal, newValue)) {
                    _.set(formChangesCopy, fieldName, _.cloneDeep(newValue));
                    _.set(formChangesResult, fieldName, _.cloneDeep(newValue));
                    applyChange = true;
                } else {
                    applyChange = false;
                }
            } else {
                if (_.includes(origVal, newValue)) {
                    // console.log(`original array already contained val ${newValue} origVal`, origVal);
                    applyChange = false;
                } else {
                    const formChangesArr = _.get(formChangesCopy, fieldName, []);
                    // console.log(`${fieldName} formChangesArr`, formChangesArr);
                    if (_.includes(formChangesArr, newValue)) {
                        // console.log(`formChangesArr field ${fieldName} array already contains val ${newValue} formChangesArr`, formChangesArr);
                        applyChange = false;
                    } else {
                        formChangesArr.push(newValue);
                        _.set(formChangesCopy, fieldName, _.cloneDeep(formChangesArr));
                        _.set(formChangesResult, fieldName, _.cloneDeep(formChangesArr));
                        applyChange = true;
                        // console.log(`formChangesArr field ${fieldName} array DID NOT have val ${newValue}, applying change`, formChangesArr);
                    }
                }
            }
        } else {
            if (String(newValue) !== String(origVal)) {
                // New value
                _.set(formChangesCopy, fieldName, newValue);
                _.set(formChangesResult, fieldName, newValue);
                applyChange = true;
            } else {
                // Same as orig val
                if (_.has(formChangesCopy, fieldName)) {
                    _.unset(formChangesCopy, fieldName);
                    _.set(formChangesResult, fieldName, newValue);
                    applyChange = true;
                }
            }
        }

        if (applyChange) {
            result.applyChanges = true;
            result.formChanges = _.cloneDeep(formChangesCopy);
            result.formChangesResult = _.cloneDeep(formChangesResult);
        }

        // console.log(`getFormChanges returns result`, result);

        return result;
    }

    public getDefaultOrderUpdateObject(associationId: any, orderId: any, statusOptions: any) {
        const folUpDate = moment().add(DefaultFollowUpAddInterval, DefaultFollowUpAddPeriod).toDate();
        const result = _.cloneDeep({
            statusOptions: statusOptions,
            associationId: associationId,
            orderId: orderId,
            statusId: '-1',
            followUpDate: folUpDate, // DefaultNewInviteExpirationDate(),
            notes: '',
        });

        return result;
    }

    public getFormData(orderIn: any, orderId: any, statuses: any) {
        const order = _.merge(orderIn, this.state.orderModalFormChanges);

        const updateOrderModalStatusOptions = (_.size(statuses)) ?
            _.orderBy(statuses.map((c) => _.merge({}, { value: Formatters.getInt(c, 'statusId'), text: Formatters.getStr(c, 'name') })), 'value')
            : [];

        const associationId = Formatters.getInt(order, 'associationId');
        // console.log(`getFormData`, { order });
        let updateOrderObj = _.get(this.state.orderModalFormChanges, 'updateOrder', this.getDefaultOrderUpdateObject(associationId, orderId, updateOrderModalStatusOptions));

        let result = {
            // association: _.get(order, 'association'),
            associationId: Formatters.getInt(order, 'associationId'),
            orderId: orderId,
            followUpDate: _.get(order, 'followUpDate'),
            status: _.get(order, 'status'),

            followUpNotesAdd: Formatters.getStr(order, 'followUpNotesAdd'),
            followUpNotesDelete: _.get(order, 'followUpNotesDelete', []),
            followUpNotes: _.get(order, 'followUpNotes', []),

            orderStatusOptions: (_.size(updateOrderModalStatusOptions)) ? updateOrderModalStatusOptions : [],

            updateOrder: updateOrderObj,

            updateNewFollowUpDate: _.get(order, 'updateNewFollowUpDate'),
            newFollowUpDate: new Date(),
        };

        // New due date
        if (result.updateNewFollowUpDate) {
            // Follow up date entered
            _.set(result, 'newFollowUpDate', moment(new Date(result.updateNewFollowUpDate)).toDate());
        } else {
            // No follow up date entered - default
            // const folUpDate = moment(new Date(result.followUpDate)).add(DefaultFollowUpAddInterval, DefaultFollowUpAddPeriod).toDate();
            const folUpDate = moment().add(DefaultFollowUpAddInterval, DefaultFollowUpAddPeriod).toDate();
            _.set(result, 'newFollowUpDate', folUpDate);
        }

        // Follow up notes
        if (_.size(result.followUpNotes)) {
            result.followUpNotes = _.filter(result.followUpNotes, (o) => Formatters.getStr(o, 'notes') !== '');
            if (_.size(result.followUpNotes)) {
                result.followUpNotes = _.orderBy(result.followUpNotes, ['created'], ['desc']);
            }
        }

        if (_.size(result.followUpNotesDelete)) {
            result.followUpNotes = _.omitBy(result.followUpNotes, (o) => _.includes(result.followUpNotesDelete, o.objectId));
        }

        const res = _.merge(result, this.state.orderModalFormChanges);

        return res;
    }

    public getOrderModalFormChangesCount() {
        return _.size(this.state.orderModalFormChanges);
    }

    public extendGridData(records: Array<any>, recordChanges: Array<any>) {
        // Extend grid row data
        if (!records) { return []; }

        const extended = records.map(r => {
            let record = _.cloneDeep(r);

            record.associationName = Formatters.getStr(record, 'association.name', '', true);
            record.contactFirstName = Formatters.getStr(record, 'contact.firstName', '', true);
            record.contactLastName = Formatters.getStr(record, 'contact.lastName', '', true);
            record.clientName = Formatters.getStr(record, 'client.name', '', true);
            record.clientPhone = Formatters.formatPhoneNumber(Formatters.getStr(record, 'client.phone'), '', '');
            record.orderStatus = Formatters.getStr(record, 'status.name', '');

            record.contactNameFormatted = Formatters.composeClientContactLetter(_.get(record, 'contact'), true, false);

            record.selected = Formatters.getBool(record, 'selected');

            record.bidDateFormatted = '';
            if (record.bidDate) {
                record.bidDateFormatted = moment(record.bidDate).format(this.MomentDateFormat);
            }

            // Follow up dates
            const followUpDateRawDate = new Date(record.followUpDate);
            record.followUpDateFormatted = (followUpDateRawDate) ? moment(followUpDateRawDate).format(this.MomentDateFormat) : '';

            if (!record.followUpDateNew) {
                const folUpDate = moment().add(DefaultFollowUpAddInterval, DefaultFollowUpAddPeriod).toDate();

                // record.followUpDateNew = new Date(moment(followUpDateRawDate).add(1, 'days').toDate());
                record.followUpDateNew = new Date(moment().add(DefaultFollowUpAddInterval, DefaultFollowUpAddPeriod).toDate());
            }

            const followUpDateNewRawDate = (record.followUpDateNew) ? new Date(record.followUpDateNew) : new Date();
            record.followUpDateFormattedNew = (followUpDateNewRawDate) ? moment(followUpDateNewRawDate).format(this.MomentDateFormat) : '';

            record.level1Economy = OrderPricing.getOrderPricingLevel1Economy(record.pricingMatrix);

            // View order detail link
            record.viewOrderDetailLinkObj = {
                text: '',
                href: '',
                title: '',
                orderId: 0,
            };
            if (record.orderId) {
                record.viewOrderDetailLinkObj.text = this.appText('view-order-detail-link-title');
                record.viewOrderDetailLinkObj.href = NavigationLinks.orderDetail(record.orderId);
                record.viewOrderDetailLinkObj.orderId = Formatters.getInt(record, 'orderId');
            }

            record.updateOrderObj = {
                text: '',
                href: '',
                title: '',
                orderId: 0,
                associationId: 0,
                clickHandler: undefined,
            };
            if (record.orderId) {
                record.updateOrderObj.text = this.appText('view-order-detail-link-title');
                record.updateOrderObj.href = NavigationLinks.orderDetail(record.orderId);
                record.updateOrderObj.orderId = Formatters.getInt(record, 'orderId');
                record.updateOrderObj.associationId = Formatters.getInt(record, 'associationId');
                record.updateOrderObj.clickHandler = (e: any, k: any, o: any, a: any) => this.handleOrderActionButton(e, k, o, a);
            }

            let recChanges = _.find(recordChanges, { orderId: record.orderId });
            if (recChanges) {
                record = _.merge(record, _.omit(recChanges, 'orderId'));
            }

            return record;
        });

        if (this.originalExtendedOrderCache.length === 0) { this.originalExtendedOrderCache = _.cloneDeep(extended); }

        return extended;
    }

    public handleSelectClient(e: any) {
        const value = _.get(e, 'value', '');
        this.props.dispatch(Actions.searchOutstandingBidsFilterClient(value));
    }

    public handleSelectRegion(e: any) {
        const value = _.get(e, 'value', '');
        this.props.dispatch(Actions.searchOutstandingBidsFilterRegion(value));
    }

    public handleSelectStatus(e: any) {
        const value = _.get(e, 'value', '');
        this.props.dispatch(Actions.searchOutstandingBidsFilterStatus(value));
    }

    public handleSelectUnsolicited(e: any) {
        const value = _.get(e, 'value', '');
        this.props.dispatch(Actions.searchOutstandingBidsFilterUnsolicitedBid(value));
    }

    public handleSelectFromBidDate(e: any) {
        const value = e ? e.format(this.MomentDateFormat) : '';
        this.props.dispatch(Actions.searchOutstandingBidsFilterFromBidDate(value));
    }

    public handleSelectToBidDate(e: any) {
        const value = e ? e.format(this.MomentDateFormat) : '';
        this.props.dispatch(Actions.searchOutstandingBidsFilterToBidDate(value));
    }

    public handleSelectFromFollowUpDate(e: any) {
        const value = e ? e.format(this.MomentDateFormat) : '';
        this.props.dispatch(Actions.searchOutstandingBidsFilterFromFollowUpDate(value));
    }

    public handleSelectToFollowUpDate(e: any) {
        const value = e ? e.format(this.MomentDateFormat) : '';
        this.props.dispatch(Actions.searchOutstandingBidsFilterToFollowUpDate(value));

    }

    public handleGridItemChange(event: any) {
        const itemField = event.field;
        const itemValueNew = event.value;
        const itemValueOld = event.dataItem[itemField];
        const orderId = _.get(event, 'dataItem.orderId');
        const origItem = _.find(this.originalExtendedOrderCache, { 'orderId': orderId });
        const origValue = _.get(origItem, itemField);

        // console.log(`handleGridItemChange orderId ${orderId} field ${itemField} changed from ${itemValueOld} to ${itemValueNew}. orig ${origValue}`, { origItem, event });

        let oChangesClone = _.cloneDeep(this.state.orderChanges);
        if (!_.find(oChangesClone, { 'orderId': orderId })) {
            const newItem = { orderId: orderId, selected: false };
            oChangesClone.push(newItem);
        }

        let order = _.find(oChangesClone, { 'orderId': orderId });
        if (order && _.get(order, itemField) !== itemValueNew) {
            if (itemValueNew === origValue) {
                // New value same as original, delete any change
                _.unset(order, itemField);
            } else {
                // New value differs from original
                _.set(order, itemField, itemValueNew);
            }

            if (_.keys(_.omit(order, 'orderId')).length === 0) {
                // No more changes for this item, remove it
                oChangesClone = _.reject(oChangesClone, { orderId: orderId });
            }

            _.set(event.dataItem, itemField, itemValueNew);

            // console.log(`handleGridItemChange orderId ${orderId} setState`, { oChangesClone });

            this.setState({ orderChanges: oChangesClone });
        }
    }

    public handleGridPageChange(event: any) {
        this.setState({
            gridVirtualSkip: event.page.skip,
            gridVirtualTake: event.page.take,
        });
    }

    public handleGridFilterChange(event: any) {
        this.setState({
            gridFilter: event.filter,
        });
    }

    public handleOrderActionButton(e: any, k: any, o: any, a?: any) {
        // console.log('handleOrderActionButton', { e, k, o, props: this.props } );

        switch (k) {
            case OutstandingBidActionKeys.setLostStatus:
                // console.log('handleOrderActionButton setlost');
                break;

            case OutstandingBidActionKeys.editOrder:
                this.props.history.push(NavigationLinks.orderEdit(o));
                break;

            case OutstandingBidActionKeys.followUp:
                this.handleShowModalUpdateOrder(e, o, a);
                break;

            default:
            case OutstandingBidActionKeys.viewDetails:
                this.props.history.push(NavigationLinks.orderDetail(o));
                break;
        }
    }

    public handleShowModalUpdateOrder(e: any, o: any, a: any) {
        // console.log('handleShowModalUpdateOrder', { e, o, a } );
        // this.setState({ showModalUpdateOrder: true, showModalUpdateOrderId: o });

        let formChanges = _.cloneDeep(this.state.orderModalFormChanges);
        const newOrderUpdateObj = this.getDefaultOrderUpdateObject(a, o, []);

        // console.log(`handleShowModalUpdateOrder newOrderUpdateObj`, { newOrderUpdateObj });

        _.set(formChanges, 'updateOrder', newOrderUpdateObj);

        this.setState({ orderModalFormChanges: formChanges, showModalUpdateOrderId: o, showModalUpdateOrder: true });
    }

    public handleCloseModalUpdateOrder() {
        this.setState({ showModalUpdateOrder: false, showModalUpdateOrderId: 0 });
    }

    public handleUpdateOrderModalButton(e: any) {
        const token = _.get(this.props, 'authsession.access_token', '');

        const rows: Array<any> = this.extendGridData(this.props.search.results, this.state.orderChanges);
        const currentOrderId = Formatters.getInt(this.state, 'showModalUpdateOrderId');
        const currentOrder = (currentOrderId > 0) ? _.find(rows, { orderId: this.state.showModalUpdateOrderId }) : {};

        let payload = _.cloneDeep(_.get(this.state, 'orderModalFormChanges.updateOrder'));

        const changeData = {
            updateOrder: payload
        };

        // console.log(`handleUpdateOrderModalButton`, { changeData, props: this.props });

        this.props.updateOutstandingBid(changeData, token, false).then(response => {
            // We can promise-chain on the mutation action to trigger state
            // transitions when it succeeds or fails.

            if (response.status >= 200 && response.status < 300) {
                this.originalOrderModalFormDataCache = {};

                this.setState({ orderModalFormChanges: {}, showModalUpdateOrder: false });

                this.props.forceRequest();
            } else {
                // Error during creation...
            }
        });
    }

    public handleChangeOrderStatus(e: any) {
        const value = _.get(e, 'value', '');
        // console.log(`handleChangeOrderStatus e`, { e, value });
    }

    public renderUpdateOrderModal = (oStatuses: any, currentOrder: any, formData?: any) => {
        const buttonSuccessDisabled = false;

        const currentOrderId = Formatters.getInt(currentOrder, 'orderId');
        const currentOrderAssocName = Formatters.getStr(currentOrder, 'association.name');
        const currentOrderAssocId = Formatters.getInt(currentOrder, 'associationId');
        const currentOrderStatusName = Formatters.getStr(currentOrder, 'status.name');
        const currentOrderFollowUpDateFormatted = Formatters.getStr(currentOrder, 'followUpDateFormatted');
        const currentOrderFollowUpDateFormattedNew = Formatters.getStr(currentOrder, 'followUpDateFormattedNew');
        const currentOrderFollowUpDateNew = _.get(formData, 'updateOrder.followUpDate');

        if (currentOrderId <= 0) { return (<div />); }

        const orderStatusOptionsRaw = _.filter(_.get(oStatuses, 'options', []), o => Formatters.getInt(o, 'value') >= 0);
        const orderStatusOptions = (_.size(orderStatusOptionsRaw)) ? orderStatusOptionsRaw.map((c) => _.merge({}, { value: Formatters.getInt(c, 'value'), text: Formatters.getStr(c, 'label') })) : [];

        // console.log(`renderUpdateOrderModal`, {
        //     currentOrderId,
        //     currentOrderFollowUpDateFormatted,
        //     currentOrderFollowUpDateFormattedNew,
        //     currentOrderFollowUpDateNew,
        //     orderStatusOptionsRaw,
        //     orderStatusOptions,
        //     currentOrder,
        //     formData
        // });

        if (!currentOrder || !currentOrderId || !currentOrderAssocId) { return (<div />); }

        const defaultInputProps = { colLabelXs: 4, colInputXs: 8 }; // colInputXs: 8 };

        let inputPropsLargeTextDebounced = _.merge({}, defaultInputProps, {
            handleChange: (n, v) => undefined,
            className: 'inventory-detail-input-full-width',
        });

        const inputPropsVirtualizedSelect = _.merge({}, defaultInputProps, {
            className: 'inventory-detail-input-full-width',
        });

        let inputPropsFullWidthOwnRow = _.merge({}, defaultInputProps, {
            // onChange: (n, v) => { console.log('onchange inputPropsFullWidthOwnRow', { n, v }); },
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
            colLabelXs: 12,
            colInputXs: 12,
        });

        let inputPropsSmallDate = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
        });

        const inputPropsNew = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
            handleChange: (n, v) => { this.handleFormInputChange(n, v); },
        });

        return (
            <Modal enforceFocus={false} show={this.state.showModalUpdateOrder} onHide={() => this.handleCloseModalUpdateOrder()}>
                <Modal.Header closeButton={true}>
                    <Modal.Title>{this.appText('modals.update-order.title')}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div>
                        <div className="outstanding-bids-update-order-modal-content">
                            <p className="outstanding-bids-update-order-modal-header-text">
                                <i className="fa fa-info-circle" /> {this.appText('modals.update-order.header-text')}.
                            </p>
                        </div>

                        <form onSubmit={e => { e.preventDefault(); }}>
                            <div className="outstanding-bids-update-order-modal-content">
                                <Row className="form-group">
                                    <Col xs={3} xl={12}>
                                        <KendoWrappers.KendoDisabledInputHidden
                                            name="_updateOrder.association"
                                            label={this.appText('modals.update-order.association')}
                                            value={(<Link to={NavigationLinks.associationDetail(currentOrderAssocId)} title={currentOrderAssocName}>{currentOrderAssocName}</Link>)}
                                            {...inputPropsLargeTextDebounced}
                                        />
                                    </Col>
                                </Row>
                                <Row className="form-group">
                                    <Col xs={3} xl={12}>
                                        <KendoWrappers.KendoDisabledInputHidden
                                            name="_updateOrder.orderId"
                                            label={this.appText('modals.update-order.order-id')}
                                            value={(<Link to={NavigationLinks.orderDetail(currentOrderId)} title={String(currentOrderId)}>{currentOrderId}</Link>)}
                                            {...inputPropsLargeTextDebounced}
                                        />
                                    </Col>
                                </Row>
                                <Row className="form-group">
                                    <Col xs={3} xl={12}>
                                        <KendoWrappers.KendoDisabledInputHidden
                                            name="_updateOrder.followUpDate"
                                            label={this.appText('modals.update-order.current-follow-up-date')}
                                            value={currentOrderFollowUpDateFormatted}
                                            {...inputPropsLargeTextDebounced}
                                        />
                                    </Col>
                                </Row>
                                <Row className="form-group">
                                    <Col xs={3} xl={12}>
                                        <KendoWrappers.KendoDisabledInputHidden
                                            name="_updateOrder.orderStatus"
                                            label={this.appText('modals.update-order.current-order-status')}
                                            value={currentOrderStatusName}
                                            // {...inputPropsLargeTextDebounced}
                                            {...inputPropsNew}
                                        />
                                    </Col>
                                </Row>
                            </div>

                            <hr />

                            <div className="outstanding-bids-update-order-modal-content">
                                <Row className="form-group">
                                    <Col xs={3} xl={12}>
                                        <KendoWrappers.KendoDropdownListInput
                                            name="updateOrder.statusId"
                                            clearable={false}
                                            label={this.appText('modals.update-order.new-order-status')}
                                            value={Formatters.getInt(formData, 'updateOrder.statusId')}
                                            data={orderStatusOptions}
                                            textField="text"
                                            valueField="value"
                                            onChange={(o) => {
                                                this.handleFormInputChange({ target: { name: 'updateOrder.statusId', type: 'kendo-dropdownlist', value: _.get(o, 'target.value') } }, o);
                                            }}
                                            {...inputPropsVirtualizedSelect}
                                        />
                                    </Col>
                                </Row>
                                <Row className="form-group">
                                    <Col xs={3} xl={12}>
                                        <KendoWrappers.KendoDateInput
                                            name="updateOrder.followUpDate"
                                            clearable={true}
                                            label={this.appText('modals.update-order.new-order-follow-up-date')}
                                            value={Formatters.formatDateForKendoDateInput(_.get(formData, 'updateOrder.followUpDate'))}
                                            {...inputPropsSmallDate}
                                        />
                                    </Col>
                                </Row>
                                <Row className="form-group">
                                    <Col xs={3} xl={12}>
                                        <KendoWrappers.KendoTextarea
                                            name="updateOrder.notes"
                                            label={this.appText('modals.update-order.new-order-follow-up-notes')}
                                            rows={2}
                                            cols={40}
                                            value={Formatters.getStr(formData, 'updateOrder.notes')}
                                            {...inputPropsFullWidthOwnRow}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="success" disabled={buttonSuccessDisabled} onClick={(e) => this.handleUpdateOrderModalButton(e)}>{this.appText('modals.update-order.button-update')}</Button>
                    <Button bsStyle="danger" onClick={() => this.handleCloseModalUpdateOrder()}>{this.appTextCommon('buttons.cancel')}</Button>

                    { /*
                        <Button bsStyle="success" disabled={this.getInputDisabled('modal-set-due-date-button', formData)} onClick={(e) => this.handleSetDueDateButton(e)}>{this.appText('set-due-date')}</Button>
                        <Button bsStyle="danger" onClick={() => this.handleCloseModalSetDueDate()}>{this.appTextCommon('buttons.cancel')}</Button>
                    */ }
                </Modal.Footer>
            </Modal>
        );
    }

    public export = () => {
        this._export.save();
    }

    public render() {
        // const rows = this.extendGridData(this.props.search.results);
        const rows: Array<any> = this.extendGridData(this.props.search.results, this.state.orderChanges);

        // const { orderDetailOrder, orderChartDetail, orderId, orders, association, users, statuses, serviceLevels, associationClient, orderClient, associations, clients, companies, ...rest } = this.props;

        // Prepare select dropdown options
        const clients = FormUtilities.getExtendedFilterOptions(this.props.filterByClients, 'clientId', 'label', this.anyOptionText, -1);
        const regions = FormUtilities.getExtendedFilterOptions(this.props.filterByRegions, 'regionId', 'label', this.anyOptionText, -1);

        let filterByStatuses = this.props.filterByStatuses;
        if (AppUtilities.isArrayWithLength(filterByStatuses)) {
            filterByStatuses = _.each(filterByStatuses, (c: any) => { c.sort = c.statusId; return c; });
            filterByStatuses.push({
                name: this.appText('filter-option-won-jobs'),
                sort: OrderStatuses.JOB_WON * -1,
                statusId: OrderStatuses.JOB_WON,
            });
        }
        const statuses = FormUtilities.getExtendedFilterOptions(filterByStatuses, 'statusId', 'sort', this.anyOptionText, -1, -1);

        let filterByUnsolicited: Array<any> = [
            { value: 1, name: this.appText('filter-option-unsolicited-yes') },
            { value: 0, name: this.appText('filter-option-unsolicited-no') },
        ];
        const unsolicited = FormUtilities.getExtendedFilterOptions(filterByUnsolicited, 'value', 'value', this.appText('filter-option-unsolicited-any'), -1, -1);

        const fromBidDateSelected = FormUtilities.getDatePickerSelectedValue(this.props.search.filters.fromBidDate);
        const toBidDateSelected = FormUtilities.getDatePickerSelectedValue(this.props.search.filters.toBidDate);

        const fromFollowUpDateSelected = FormUtilities.getDatePickerSelectedValue(this.props.search.filters.fromFollowUpDate);
        const toFollowUpDateSelected = FormUtilities.getDatePickerSelectedValue(this.props.search.filters.toFollowUpDate);

        const pageTitle = this.appTextResultsAndPageTitle(rows.length);

        const rowRenderer = (trElement: React.ReactElement<any>, dataItem: any) => {
            const trProps = { ...trElement.props };

            const addClass = _.get(dataItem.dataItem, GridUtilities.KendoGridAddRowClassFieldName, '');
            if (addClass) { trProps.className += ` ${addClass}`; }

            return React.cloneElement(trElement, { ...trProps }, trElement.props.children);
        };

        const gridDataFiltered = filterBy(rows, this.state.gridFilter);
        let gridData = gridDataFiltered.slice(this.state.gridVirtualSkip, this.state.gridVirtualTake + this.state.gridVirtualSkip);

        const currentOrderId = Formatters.getInt(this.state, 'showModalUpdateOrderId');
        const currentOrder = (currentOrderId > 0) ? _.find(rows, { orderId: this.state.showModalUpdateOrderId }) : {};

        const formData = this.getFormData(currentOrder, currentOrderId, this.props.filterByStatuses);

        if (this.getOrderModalFormChangesResetRequired() || !_.size(this.originalOrderModalFormDataCache)) {
            this.originalOrderModalFormDataCache = _.cloneDeep(formData);
        }

        const updateOrderColumn = [
            <Column
                field="updateOrderObj"
                key="updateOrderObj"
                title=" "
                editable={false}
                width="100px"
                filterable={false}
                cell={GridCellDropdownActionsOutstandingBids}
                headerClassName={`k-grid-column-row-dropdown-actions`}
            />
        ];

        const grid = (
            <ExcelExport
                ref={(exporter) => { this._export = exporter; }}
                data={gridDataFiltered}
                fileName={'OutstandingBids.xlsx'}
            >
                <Grid
                    key="outstanding-bids-grid-1"
                    data={gridData}
                    resizable={true}
                    rowRender={rowRenderer}
                    filterable={true}
                    filter={this.state.gridFilter}
                    // @ts-ignore
                    filterChange={(e) => { this.handleGridFilterChange(e); }}
                    style={{ width: '100%', height: '500px' }}
                    skip={this.state.gridVirtualSkip}
                    take={this.state.gridVirtualTake}
                    total={_.size(rows)}
                    pageable={true}
                    pageChange={(e) => { this.handleGridPageChange(e); }}
                >
                    <GridToolbar>
                        <Button className="reminder-bids-grid-toolbar-button" disabled={false} bsSize="sm" bsStyle={'info'} onClick={this.export}>
                            <i className="fa fa-file-excel-o" /> {this.appText('export-to-excel')}
                        </Button>
                    </GridToolbar>
                    <Column field="associationId" key="col-associationID" title={this.appTextGridColumnHeader('association-id')} width="60px" editable={false} resizable={true} cell={CellWithTruncate} filter="numeric" />
                    <Column field="associationName" key="col-associationName" title={this.appTextGridColumnHeader('association-name')} editable={false} cell={CellWithTruncate} />
                    <Column field="contactNameFormatted" key="col-contactName" title={this.appTextGridColumnHeader('contact-name')} width="120px" editable={false} cell={CellWithTruncate} />
                    <Column field="clientName" key="col-clientName" title={this.appTextGridColumnHeader('client-name')} editable={false} cell={CellWithTruncate} />
                    <Column field="clientPhone" key="col-clientPhone" title={this.appTextGridColumnHeader('client-phone')} width="105px" editable={false} cell={CellWithTruncate} />
                    <Column field="orderStatus" key="col-orderStatus" title={this.appTextGridColumnHeader('order-status')} width="120px" editable={false} cell={CellWithTruncate} />
                    <Column field="bidDateFormatted" key="col-bidDate" title={this.appTextGridColumnHeader('bid-date')} width="80px" editable={false} cell={CellWithTruncate} />
                    <Column field="followUpDateFormatted" key="col-followUpDate" title={this.appTextGridColumnHeader('follow-up-date')} width="80px" editable={false} cell={CellWithTruncate} />
                    <Column field="level1Economy" key="col-level1Economy" title={this.appTextGridColumnHeader('level-1-economy')} width="100px" className="right-align" format="{0:c0}" editable={false} filterable={false} />
                    {...updateOrderColumn}

                </Grid>
            </ExcelExport>
        );

        const filterForm = (
            <form onSubmit={e => { e.preventDefault(); }}>
                <Row className="form-group">
                    { /* <Col xs={3} xl={2}>
                        <label className="control-label">{this.appText('filter-by-status')}</label>
                        <VirtualizedSelect
                            clearable={false}
                            filterOptions={statuses.filter}
                            name="status-filter"
                            onChange={e => this.handleSelectStatus(e)}
                            options={statuses.options}
                            value={this.props.search.filters.statusId}
                        />
                    </Col> */ }
                    <Col xs={4} xl={2}>
                        <label className="control-label">{this.appText('filter-by-from-bid-date')}</label>
                        <DatePicker className="form-control" onChange={e => { this.handleSelectFromBidDate(e); }} selected={fromBidDateSelected} />
                    </Col>

                    <Col xs={4} xl={2}>
                        <label className="control-label">{this.appText('filter-by-to-bid-date')}</label>
                        <DatePicker className="form-control" onChange={e => { this.handleSelectToBidDate(e); }} selected={toBidDateSelected} />
                    </Col>

                    <Col xs={4} xl={2}>
                        <label className="control-label">{this.appText('filter-by-region')}</label>
                        <VirtualizedSelect
                            clearable={false}
                            filterOptions={regions.filter}
                            name="region-filter"
                            onChange={e => this.handleSelectRegion(e)}
                            options={regions.options}
                            value={this.props.search.filters.regionId}
                        />
                    </Col>
                    { /* <Col xs={4} xl={3}>
                        <label className="control-label">{this.appText('filter-by-client')}</label>
                        <VirtualizedSelect
                            clearable={false}
                            filterOptions={clients.filter}
                            name="client-filter"
                            onChange={e => this.handleSelectClient(e)}
                            options={clients.options}
                            value={this.props.search.filters.clientId}
                        />
                    </Col>

                    <Col xs={2} xl={2}>
                        <label className="control-label">{this.appText('filter-by-unsolicited-bid')}</label>
                        <VirtualizedSelect
                            clearable={false}
                            filterOptions={unsolicited.filter}
                            name="unsolicited-filter"
                            onChange={e => this.handleSelectUnsolicited(e)}
                            options={unsolicited.options}
                            value={this.props.search.filters.unsolicitedBid}
                        />
                </Col> */ }
                </Row>
                <Row className="form-group">
                    { /* <Col xs={3} xl={2}>
                        <label className="control-label">{this.appText('filter-by-from-bid-date')}</label>
                        <DatePicker className="form-control" onChange={e => {this.handleSelectFromBidDate(e); }} selected={fromBidDateSelected} />
                    </Col>

                    <Col xs={3} xl={2}>
                        <label className="control-label">{this.appText('filter-by-to-bid-date')}</label>
                        <DatePicker className="form-control" onChange={e => {this.handleSelectToBidDate(e); }} selected={toBidDateSelected} />
                </Col> */ }

                    <Col xs={4} xl={3}>
                        <label className="control-label">{this.appText('filter-by-client')}</label>
                        <VirtualizedSelect
                            clearable={false}
                            filterOptions={clients.filter}
                            name="client-filter"
                            onChange={e => this.handleSelectClient(e)}
                            options={clients.options}
                            value={this.props.search.filters.clientId}
                        />
                    </Col>

                    <Col xs={3} xl={2}>
                        <label className="control-label">{this.appText('filter-by-from-follow-up-date')}</label>
                        <DatePicker className="form-control" onChange={e => { this.handleSelectFromFollowUpDate(e); }} selected={fromFollowUpDateSelected} />
                    </Col>

                    <Col xs={3} xl={2}>
                        <label className="control-label">{this.appText('filter-by-to-follow-up-date')}</label>
                        <DatePicker className="form-control" onChange={e => { this.handleSelectToFollowUpDate(e); }} selected={toFollowUpDateSelected} />
                    </Col>

                    <Col xs={2} xl={2}>
                        <label className="control-label">{this.appText('filter-by-unsolicited-bid')}</label>
                        <VirtualizedSelect
                            clearable={false}
                            filterOptions={unsolicited.filter}
                            name="unsolicited-filter"
                            onChange={e => this.handleSelectUnsolicited(e)}
                            options={unsolicited.options}
                            value={this.props.search.filters.unsolicitedBid}
                        />
                    </Col>
                </Row>
            </form>
        );

        const page = (
            <WhiteBoxPageSection title={pageTitle} >
                {this.renderUpdateOrderModal(statuses, currentOrder, formData)}
                <Row>
                    <Col xs={12}>
                        {filterForm}
                    </Col>
                </Row>

                <Row>
                    <Col xs={12}>
                        {grid}
                    </Col>
                </Row>
            </WhiteBoxPageSection>
        );

        const { ...rest } = this.props;
        return (
            <AppComp.RenderPageWithLayout branding={this.props.branding} pageName={pageTitle} {...rest}>
                {page}
            </AppComp.RenderPageWithLayout>
        );
    }
}

const getFiltersApiUrl = () => ApiEndpoints.getOutstandingBidsSearchFiltersUrl();
const getApiUrl = () => ApiEndpoints.getOutstandingBidsSearchUrl();

const mapPropsToConfigs = (props) => {
    const fromBidDate = _.get(props, 'search.filters.fromBidDate', '');
    const toBidDate = _.get(props, 'search.filters.toBidDate', '');
    const statusId = _.get(props, 'search.filters.statusId', -1);
    const clientId = _.get(props, 'search.filters.clientId', -1);
    const regionId = _.get(props, 'search.filters.regionId', -1);
    const fromFollowUpDate = _.get(props, 'search.filters.fromFollowUpDate', '');
    const toFollowUpDate = _.get(props, 'search.filters.toFollowUpDate', '');
    const unsolicitedBid = _.get(props, 'search.filters.unsolicitedBid', -1);
    const operator = _.get(props, 'search.filters.operator', '');

    const currentFilters = {
        clientId,
        fromFollowUpDate,
        toFollowUpDate,
        fromBidDate,
        regionId,
        statusId,
        toBidDate,
        unsolicitedBid
    };

    const isInitialFilters = _.isEqual(currentFilters, _.omit(initialState, ['selectedOrderIds']));

    if (isInitialFilters) {
        const haveFilterOptions = (
            (props.filterByClients && props.filterByClients.length > 0) ||
            (props.filterByRegions && props.filterByRegions.length > 0) ||
            (props.filterByStatuses && props.filterByStatuses.length > 0)
        );

        if (haveFilterOptions) {
            const hasResults = Array.isArray(_.get(props, 'search.results')) && _.get(props, 'search.results.length', 0) > 0;

            if (props.dispatch && hasResults) {
                props.dispatch(updateEntities({ outstandingBidsResults: () => [] }));
            }

            return null;
        }

        return (
            ReduxQueries.Queries.searchOutstandingBidsFiltersRequest(
                getFiltersApiUrl(),
                ReduxQueries.PropsAccessToken(props),
            )
        );
    }

    return (
        ReduxQueries.Queries.searchOutstandingBidsRequest(
            getApiUrl(),
            ReduxQueries.PropsAccessToken(props),
            fromBidDate,
            toBidDate,
            statusId,
            clientId,
            regionId,
            fromFollowUpDate,
            toFollowUpDate,
            unsolicitedBid,
            operator,
        )
    );
};

const mapStateToProps = (state, props) => {
    return ReduxQueries.MapQueryStateToPropsByUrl(getApiUrl(), state, props, {
        filterByClients: state.entities.outstandingBidsClients,
        filterByRegions: state.entities.outstandingBidsRegions,
        filterByStatuses: state.entities.outstandingBidsStatuses,
        filterBySelectedOrderIds: state.searchFiltersOutstandingBids.selectedOrderIds,
        search: {
            results: state.entities.outstandingBidsResults,
            filters: {
                clientId: state.searchFiltersOutstandingBids.clientId,
                fromFollowUpDate: state.searchFiltersOutstandingBids.fromFollowUpDate,
                toFollowUpDate: state.searchFiltersOutstandingBids.toFollowUpDate,
                fromBidDate: state.searchFiltersOutstandingBids.fromBidDate,
                operator: 'AND',
                regionId: state.searchFiltersOutstandingBids.regionId,
                statusId: state.searchFiltersOutstandingBids.statusId,
                toBidDate: state.searchFiltersOutstandingBids.toBidDate,
                unsolicitedBid: state.searchFiltersOutstandingBids.unsolicitedBid,
            }
        },
    });
};

const mapDispatchToProps = dispatch => ({
    navigateTo: (path) => dispatch(push(path)),
    dispatch: (d) => dispatch(d),
    searchOutstandingBidsFilterClient: (v) => dispatch(Actions.searchOutstandingBidsFilterClient(v)),
    searchOutstandingBidsFilterRegion: (v) => dispatch(Actions.searchOutstandingBidsFilterRegion(v)),
    searchOutstandingBidsFilterStatus: (v) => dispatch(Actions.searchOutstandingBidsFilterStatus(v)),
    searchOutstandingBidsFilterUnsolicitedBid: (v) => dispatch(Actions.searchOutstandingBidsFilterUnsolicitedBid(v)),
    searchOutstandingBidsFilterFromBidDate: (v) => dispatch(Actions.searchOutstandingBidsFilterFromBidDate(v)),
    searchOutstandingBidsFilterToBidDate: (v) => dispatch(Actions.searchOutstandingBidsFilterToBidDate(v)),
    searchOutstandingBidsFilterFromFollowUpDate: (v) => dispatch(Actions.searchOutstandingBidsFilterFromFollowUpDate(v)),
    searchOutstandingBidsFilterToFollowUpDate: (v) => dispatch(Actions.searchOutstandingBidsFilterToFollowUpDate(v)),
    updateOutstandingBid: (d: any, a: string, o: boolean) => dispatch(MutateActions.updateOutstandingBidMutateAsync(d, a, o)),
});

const OutstandingBidsContainer = compose<any>(
    connect(mapStateToProps, mapDispatchToProps),
    connectRequest(mapPropsToConfigs)
)(OutstandingBids);

export default withRouter(OutstandingBidsContainer);



// WEBPACK FOOTER //
// ./src/outstanding-bids/index.tsx